export class GSI2Configuration {
  domain = '';
  clientId = '';
  audience = '';
  scope = '';
  apiUrl = '';
  env = '';
}
